import { render, staticRenderFns } from "./FavoriteExhibitors.vue?vue&type=template&id=ee42acb0&scoped=true&"
import script from "./FavoriteExhibitors.vue?vue&type=script&lang=js&"
export * from "./FavoriteExhibitors.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteExhibitors.vue?vue&type=style&index=0&id=ee42acb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee42acb0",
  null
  
)

export default component.exports